<vault-shared-folders>
  <app-header>
    <vault-shared-folders-breadcrumbs slot="breadcrumbs" />
  </app-header>
</vault-shared-folders>
